
import React from "react";
import ReactDOM from "react-dom/client";
import ConfirmDialogModel from "./ConfirmDialogModal";
export function $confirmDialog(message: string, heading?: string,btn1?:any,btn2?:any): Promise<boolean> {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const root = ReactDOM.createRoot(container);

    const cleanup = () => {
      root.unmount();
      container.remove();
    };

    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(false);
    };

    root.render(
      <ConfirmDialogModel
        message={message}
        heading={heading}
        btn1={btn1}
        btn2={btn2}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    );
  });
}
